import React, { Component } from "react";

class CadastroObservacao extends Component {
  render() {
    let styleContraste = {
      border: "1px dashed #777",
      fontWeight: "700",
      background: "#fff"
    }

    return (
      <div className="row">
        <div className="col-12 grid-margin">
          <div className="card">
            <div className="card-body">
              <h4 className="card-title">OBSERVAÇÕES</h4>
              <div className="form-group row">
                <div className="col-md-12">
                  <textarea
                    style={styleContraste}
                    disabled
                    rows="8"
                    placeholder="NÃO INFORMADO"
                    name="observacoes"
                    className="form-control"
                    value={this.props.observacoes}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default CadastroObservacao;
